module.exports = __webpack_public_path__ + "img/15df058.jpg";